export class BankDetailsModel {
    public sort_code: string|undefined = "";
    public bank_account_number: string|undefined = "";
    public bank_account_holder_name: string|undefined = "";
}
  